var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "info-installment",
    class: {
      'info-installment_loading': _vm.isLoading
    },
    on: {
      "click": function ($event) {
        return _vm.onEnable();
      }
    }
  }, [!_vm.isLoading ? [_c('img', {
    attrs: {
      "src": require("assets/images/installment/logo.svg"),
      "alt": "Рассрочка"
    }
  }), _vm._v(" "), _vm.downPayment.value ? _c('div', {
    staticClass: "info-installment__info"
  }, [_c('p', {
    staticClass: "info-installment__payment"
  }, [_vm._v("\n        В рассрочку за " + _vm._s(_vm.formatPrice(_vm.downPayment.value)) + " ₽\n      ")])]) : _vm._e()] : _vm._e()], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }